import { render } from "./Sub_Announcements.vue?vue&type=template&id=c51e2442"
import script from "./Sub_Announcements.vue?vue&type=script&lang=js"
export * from "./Sub_Announcements.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__